/* eslint-disable no-console */
import _get from 'lodash/get'

import history from 'routes/history'

import { STRING } from 'resources'
import { APP_URLS } from 'resources/urls'
import generalActions from 'models/General/actions'

const DEBUG = process.env.NODE_ENV === 'development'

/**
 * Centralized error handling for the app. Dispatch this action whenever errors occur.
 * Let's not leave errors hanging ⛔️
 */

const GENERIC_ERROR_MSG = 'Your request cannot be processed at this time. Please try again later.'
const AUTO_SIGN_OUT_DELAY_MS = 200

const isResponseError = (err) => err && err.response && err.response.status && err.response.status >= 500

const isNetworkError = (err) => String(err).includes('Network request failed')

const getBodyText = (err) => _get(err, ['response', '_bodyText'], '')

const isPhoneError = (err) => {
  const bodyText = getBodyText(err)
  const isNotNumber = bodyText.includes('is not a mobile number')
  const isNotValid = bodyText.includes('is not a valid phone number')

  return isNotNumber || isNotValid
}

export default function handleError(err) {
  let error = {}
  if (DEBUG) {
    console.log('[handleError] Error:', err)
    if (err.response) {
      console.log('[handleError] Error Response:', err.response)
    }
  }
  if (isResponseError(err)) {
    error = new Error(GENERIC_ERROR_MSG)
  }
  if (err.response && err.response.data) {
    if (err.response.status === 401) {
      setTimeout(() => {
        history.replace({
          pathname: APP_URLS.SIGN_OUT,
          state: { unauthorizedAccountSignOutRedirect: true },
        })
      }, AUTO_SIGN_OUT_DELAY_MS)
      return { type: 'EMPTY' }
    }
    error = err.response.data
    if (!error.message) {
      const BreakException = {}
      try {
        Object.keys(error).forEach((key) => {
          if (Array.isArray(error[key])) {
            const firstError = error[key][0]
            error.message = firstError
            throw BreakException
          }
        })
      } catch (e) {
        console.error(e)
      }
    }
  }

  if (isNetworkError(err)) {
    error.message = 'Please check your network connection.'
  }

  if (isPhoneError(err)) {
    error.title = STRING.phoneValidationErrorTitle
    error.message = STRING.phoneValidationErrorBody
  }
  return generalActions.showGeneralModal.success({
    modalTitle: error.title || STRING.anErrorHasOccurred,
    modalMessage: error.message || GENERIC_ERROR_MSG,
    buttonLabel: STRING.close,
  })
}
